import { Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CompletedRegistrationsTable from '../components/completedRegistrationsTable';

interface Props {
  fetching: boolean;
}

const Wrapper: FC<Props> = ({ fetching }) => {
  const { t } = useTranslation('registrations');

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs style={{ marginTop: '20px' }}>
          <Typography variant="h4" component="div" gutterBottom>
            {t('registrations.general.completedRegistrations', { context: 'plural' })}
          </Typography>
        </Grid>
      </Grid>
      <CompletedRegistrationsTable isLoadingResults={fetching} />
    </>
  );
};

export default Wrapper;
